import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http'
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorComponent } from './error/error.component';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private dialog: MatDialog,private router:Router,private authService:AuthService){}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse)=>{
        // This screen handles every failure with a toast, including non-JSON errors.
        const handledByImpersonationScreen = /\/api\/hubTransfer\/getImpPasswd\/?(?:\?|$)/.test(req.url);
        if(error.status == 401){
          this.authService.logout();
          if(handledByImpersonationScreen) return throwError(error);
          return;
        }
        if(handledByImpersonationScreen) {
          return throwError(error);
        }
        let errorMessage = "An unknown error occured";
        let errorMessageTitle = "Something wrong!";
        if(error.error.message){
          errorMessage = error.error.message
          errorMessageTitle = error.error.messageTitle
        }
        this.dialog.open(ErrorComponent, {data: {message: errorMessage, messageTitle: errorMessageTitle}});
        return throwError(error);
      })
    );
  }

}
